import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  currentTheme: 'Dark Peacock'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, action) {
      state.currentTheme = action.payload;
    }
  }
});

export const {setTheme} = themeSlice.actions;
export const selectCurrentTheme = (state) =>
  state.theme?.currentTheme ?? 'Dark Peacock';
export default themeSlice.reducer;
